export const roundTripMessage = (start) => ({
  type: 'signal:round:trip',
  start,
})

export const roundTripTime = (data) => ({
  ...data,
  type: 'signal:rtt',
})
